module.exports = __webpack_public_path__ + "static/media/arcgis_online-tnm_base_data_map.d2ba08b0.png";